import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background-color: #f8f8f8;
  position: fixed;
  z-index: 1000;
  top: 0;
  animation: hide-loader 1s forwards; /* forwards */
  animation-delay: 0.5s;
  transition: 0.5s;

  .p-anim-loading {
    width: 100px;
    height: 100px;
    margin: 200px auto;
    background-color: transparent;
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2230%22%20height%3D%2228%22%20viewBox%3D%220%200%2030%2028%22%3E%20%3Cdefs%3E%20%3CclipPath%20id%3D%22clip-Logomark%22%3E%20%3Crect%20width%3D%2230%22%20height%3D%2228%22%2F%3E%20%3C%2FclipPath%3E%20%3C%2Fdefs%3E%20%3Cg%20id%3D%22Logomark%22%20clip-path%3D%22url(%23clip-Logomark)%22%3E%20%3Cpath%20id%3D%22%E5%90%88%E4%BD%93_1%22%20data-name%3D%22%E5%90%88%E4%BD%93%201%22%20d%3D%22M7.657%2C25.663a.59.59%2C0%2C0%2C1-.51-.294L.078%2C13.127a.592.592%2C0%2C0%2C1%2C0-.589L7.147.294A.59.59%2C0%2C0%2C1%2C7.657%2C0H21.794a.584.584%2C0%2C0%2C1%2C.266.064L15.788%2C4.749l-8.32%2C6.214h-.04V.219h0V25.445h0V14.7H27.238a.638.638%2C0%2C0%2C1%2C.1.009.592.592%2C0%2C0%2C1%2C.315.163l.131.131a.59.59%2C0%2C0%2C1%2C.094.711L22.3%2C25.369a.588.588%2C0%2C0%2C1-.51.294Zm8.135-4.729L11.61%2C23.19l4.183-2.255L7.447%2C14.7ZM7.468%2C10.964l8.32-6.215%2C11.465%2C6.214H7.468Zm8.32-6.215L22.06.064a.59.59%2C0%2C0%2C1%2C.212.18.6.6%2C0%2C0%2C1%2C.032.05l.535.928L27.878%2C9.95a.588.588%2C0%2C0%2C1-.094.71l-.131.131a.6.6%2C0%2C0%2C1-.4.172Z%22%20transform%3D%22translate(1%201.168)%22%20fill%3D%22%233ec7b3%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_1%22%20data-name%3D%22%E3%83%91%E3%82%B9%201%22%20d%3D%22M671.044%2C219.771V194.545l8.36%2C4.53%2C6.272-4.685a.592.592%2C0%2C0%2C0-.266-.064H671.273a.59.59%2C0%2C0%2C0-.51.294l-7.068%2C12.243a.589.589%2C0%2C0%2C0%2C0%2C.589l7.068%2C12.243a.59.59%2C0%2C0%2C0%2C.51.294H685.41a.585.585%2C0%2C0%2C0%2C.252-.057l-6.253-4.671Z%22%20transform%3D%22translate(-662.616%20-193.158)%22%20fill%3D%22%233ec7b3%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_2%22%20data-name%3D%22%E3%83%91%E3%82%B9%202%22%20d%3D%22M687.045%2C199.3l-8.359-4.53v10.744h.04Z%22%20transform%3D%22translate(-670.257%20-193.383)%22%20fill%3D%22%237ad8cb%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_3%22%20data-name%3D%22%E3%83%91%E3%82%B9%203%22%20d%3D%22M678.685%2C224.148v10.744l8.365-4.51-8.347-6.235Z%22%20transform%3D%22translate(-670.257%20-208.279)%22%20fill%3D%22%237ad8cb%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_4%22%20data-name%3D%22%E3%83%91%E3%82%B9%204%22%20d%3D%22M702.165%2C234.826l5.574-9.655a.589.589%2C0%2C0%2C0-.094-.711l-.131-.131a.589.589%2C0%2C0%2C0-.314-.163l-11.547%2C6.225%2C6.253%2C4.671A.587.587%2C0%2C0%2C0%2C702.165%2C234.826Z%22%20transform%3D%22translate(-678.861%20-208.289)%22%20fill%3D%22%236cd4c5%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_5%22%20data-name%3D%22%E3%83%91%E3%82%B9%205%22%20d%3D%22M678.722%2C224.148l8.346%2C6.235%2C11.547-6.225a.586.586%2C0%2C0%2C0-.1-.009Z%22%20transform%3D%22translate(-670.276%20-208.279)%22%20fill%3D%22%239ae1d7%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_6%22%20data-name%3D%22%E3%83%91%E3%82%B9%206%22%20d%3D%22M707.734%2C204.34l-5.039-8.727-.535-.928c-.01-.017-.021-.034-.033-.05a.589.589%2C0%2C0%2C0-.211-.18l-6.272%2C4.685%2C11.465%2C6.214a.59.59%2C0%2C0%2C0%2C.4-.172l.131-.131A.589.589%2C0%2C0%2C0%2C707.734%2C204.34Z%22%20transform%3D%22translate(-678.856%20-193.223)%22%20fill%3D%22%236cd4c5%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_9%22%20data-name%3D%22%E3%83%91%E3%82%B9%209%22%20d%3D%22M698.536%2C210.175h.016l-11.465-6.214-8.319%2C6.215Z%22%20transform%3D%22translate(-670.299%20-198.043)%22%20fill%3D%22%239ae1d7%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_7%22%20data-name%3D%22%E3%83%91%E3%82%B9%207%22%20d%3D%22M718.888%2C216.566h0Z%22%20transform%3D%22translate(-690.634%20-204.434)%22%20fill%3D%22%237ad8cb%22%2F%3E%20%3Cpath%20id%3D%22%E3%83%91%E3%82%B9_8%22%20data-name%3D%22%E3%83%91%E3%82%B9%208%22%20d%3D%22M718.888%2C216.566h0Z%22%20transform%3D%22translate(-690.634%20-204.434)%22%20fill%3D%22%23fff%22%20opacity%3D%220.24%22%2F%3E%20%3C%2Fg%3E%3C%2Fsvg%3E');
    border-radius: 100%;
    background-size: 100px 100px;
    animation: whirly-loader 1.5s infinite ease-in-out;
  }

  @-moz-keyframes whirly-loader {
    0% {
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    30% {
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes whirly-loader {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    30% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes whirly-loader {
    0% {
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    30% {
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes hide-loader {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      display: none;
      z-index: -1000;
    }
  }
`

/**
 * 画面ローディングアニメーション
 * @constructor
 */

const AnimLoading = (): JSX.Element => (
  <Wrapper className="p-wrapper-loading">
    <div className="p-anim-loading" />
  </Wrapper>
)

export default AnimLoading
